import React, { useState, useEffect, useContext } from "react";
import { Button, Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import {
    excelMapping,
    ExportToExcel,
    twoDecimalPlaces,
} from "../../utils/utilFuctions";
import { BASE_URL_APISERVICES } from "../../utils/Constants";
import { CLIENT } from "../../config";
import { GlobalContext } from "../../Context/GlobalState";
import { offsetArr } from "../../utils/CommonConfig";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import swal from "sweetalert";
import {
    getPaynnowTransactionStatus,
    getPaynnowTransactionStatus2,
} from "../util/utility";
import { Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import popupImage from "../../../assets/images/invoice.png";
import JSONTable from "../../utils/JsonTable";
import cogoToast from "cogo-toast";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";
import { adminAuth } from "../../config";
export const columns = [
    {
        dataField: "id",
        text: "id",
    },
    {
        dataField: "user_id",
        text: "User id",
    },
    {
        dataField: "mobile",
        text: "mobile",
    },
    {
        dataField: "ip_address",
        text: "ip_address",
    },
    {
        dataField: "latitude",
        text: "latitude",
    },
    {
        dataField: "longitude",
        text: "longitude",
    },
    {
        dataField: "device_id",
        text: "device_id",
    },
    {
        dataField: "device_type",
        text: "device_type ",
    },
    {
        dataField: "device_model",
        text: "device_model",
    },
    {
        dataField: "user_agent",
        text: "user_agent",
    },
    {
        dataField: "app_version",
        text: "app_version",
    },
    {
        dataField: "is_suspicious",
        text: "is_suspicious",
    },
    {
        dataField: "attempt_time",
        text: "attempt_time",
    },
    {
        dataField: "is_success",
        text: "is_success",
    },
];

const UserAttemptsTable = () => {
    const { username1, password1 } = adminAuth;
    const [pageAccess, setPageAccess] = useState({});
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchText, setSearchText] = useState("");
    const [offset, setOffset] = useState(10);
    const [dataToDisplay, setDataToDisplay] = useState([]);
    const [pages, setPages] = useState(0);
    const [total, setTotal] = useState(0);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const { user, setTransactionLoaderState } = useContext(GlobalContext);
    const [modalOpen2, setModalOpen2] = useState(false);
    const [billDetails, setBillDetails] = useState({});
    const [amount, setAmount] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [providerResponse, setProviderResponse] = useState({});
    const [modalOpen, setModalOpen] = useState(false);

    const initialState = {
        name: "",
        code: "",
        service: "",
    };

    const [state, setState] = useState(initialState);

    const handleShow = () => setShowModal(true);
    // const handleClose = () => setShowModal(false);

    const [selectedRowData, setSelectedRowData] = useState(null);
    const [isSideSectionVisible, setIsSideSectionVisible] = useState(false);
    const handleRowClick = (rowData) => {
        setSelectedRowData(rowData);
        setIsSideSectionVisible(true);
    };

    const handleClose = () => {
        setIsSideSectionVisible(false);
    };

    const dateFormatter = (date) => {
        return `${date.getFullYear()}-${date.getMonth() > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)
            }-${date.getDate() > 9 ? date.getDate() : "0" + date.getDate()}`;
    };
    const now = (date = new Date()) => {
        return `${date.getFullYear()}-${date.getMonth() > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)
            }-${date.getDate() > 9 ? date.getDate() : "0" + date.getDate()}`;
    };
    const 
    getAllUserLoginAttempts = async () => {
        try {
            setTransactionLoaderState(true);
            const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append(
                "Authorization",
                "Basic " + Buffer.from(username1 + ":" + password1).toString("base64")
                );
                
            var raw = JSON.stringify({
                userid:state.name,
                fromDate: dateFormatter(startDate),
                toDate: dateFormatter(endDate),
            });


            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };

            const res = await fetch(
                `${BASE_URL_APISERVICES}${API_ENDPOINTS.LOGIN_USER_ATTEMPTS}`,
                requestOptions
            )
                .then((response) => response.json())
                .then((result) => {
                    if (result.responseCode == "00") {
                        setData(result.data);
                        setTransactionLoaderState(false);

                    } else {
                        setData([]);
                        setTransactionLoaderState(false);

                    }
                })
                .catch((error) => console.log("error", error));
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        let filteredData = data.filter((bank) => {
            let b = false;
            if (data.length > 0) {
                for (let key in data[0]) {
                    if (
                        bank[key] &&
                        bank[key]
                            .toString()
                            .toLowerCase()
                            .includes(searchText.toString().toLowerCase())
                    ) {
                        b = true;
                    }
                }
            }
            return b;
        });
        setPages(Math.floor((filteredData.length + (offset - 1)) / offset));
        setTotal(filteredData.length);
        const startIdx = 0;
        const endIdx = offset - 1;
        filteredData = filteredData.filter((bank, idx) => {
            return idx <= endIdx && idx >= startIdx;
        });
        setDataToDisplay(filteredData);
        setCurrentPage(1);
    }, [searchText]);

    useEffect(() => {
        let filteredData = data.filter((bank) => {
            let b = false;
            if (data.length > 0) {
                for (let key in data[0]) {
                    if (
                        bank[key] &&
                        bank[key]
                            .toString()
                            .toLowerCase()
                            .includes(searchText.toString().toLowerCase())
                    ) {
                        b = true;
                    }
                }
            }
            return b;
        });
        console.log(filteredData);
        const startIdx = (currentPage - 1) * offset;
        const endIdx = currentPage * offset - 1;
        console.log({ startIdx, endIdx });
        filteredData = filteredData.filter((bank, idx) => {
            console.log(idx, idx <= endIdx && idx >= startIdx);
            return idx <= endIdx && idx >= startIdx;
        });
        setDataToDisplay(filteredData);
        console.log({ startIdx, endIdx });
    }, [currentPage]);

    // did mount
    useEffect(() => {
        setPages(Math.floor((data.length + (offset - 1)) / offset));
        const startIdx = 0;
        const endIdx = offset - 1;
        setTotal(data.length);
        console.log(startIdx);
        console.log(data);
        const filteredData = data.filter((bank, idx) => {
            return idx <= endIdx && idx >= startIdx;
        });
        console.log(filteredData);
        setDataToDisplay(filteredData);
    }, [data, offset]);

    const searchBarStyle = {
        display: "flex",
        alignItems: "center",
        border: "1px solid #ccc",
        borderRadius: "6px",
        padding: "0px",
        backgroundColor: "#fff",
        width: "15%", // Adjust the width as needed
        height: "20%",
    };
    const inputStyle = {
        border: "none",
        outline: "none",
        backgroundColor: "transparent",
        fontSize: "16px",
        marginLeft: "8px",
        width: "100%",
        fontFamily: "Poppins",
        fontWeight: "400",
    };
    const iconStyle = {
        color: "rgba(0, 0, 0, 0.5)",
    };

    const positionStyle = {
        position: "absolute",
        top: -27,
        left: 0,
        fontFamily: "Poppins",
        color: "rgba(255, 255,255, 1)",
    };
    const positionStyle1 = {
        position: "absolute",
        top: -38,
        left: 0,
        fontFamily: "Poppins",
        color: "rgba(255, 255,255, 1)",
    };

      const fetchData = () => {
    getAllUserLoginAttempts();
  };
    return (
        <>
       
            <div>
                <div className="row m-0 p-0 pt-1 align-items-center">
                    <div className="col-3 m-0 p-0">
                        <div
                            className="m-0 p-0 pl-3 align-top"
                            style={{
                                fontFamily: "Poppins",
                                fontWeight: "600",
                                lineHeight: "48px",
                                letterSpacing: "0em",
                                textAlign: "left",
                                padding: "0px",
                                background: "#FFFFFF",
                                color: "#4267B2",
                                fontWeight: "bolder",
                                fontfamily: "Poppins !impotent",
                                fontSize: "28px",
                            }}
                        >
                            User Login Details
                        </div>
                    </div>

                       <div className="col-9 m-0 p-0 ">
                              <div className="row m-0 p-0 justify-content-end">
                                <div>
                                  <Form.Group>
                                    <Form.Control
                                      type="text"
                                      className="form-control rounded-lg"
                                      aria-label="Notes"
                                      aria-describedby="basic-addon1"
                                      placeholder="Enter User Code"
                                      value={state.name}
                                      onChange={(e) => {
                                        setState({ ...state, name: e.target.value });
                                      }}
                                      style={{ borderRadius: "0px" }}
                                    />
                                  </Form.Group>
                                </div>
                                <div
                className="pr-1 pl-2 p-0 m-0"
                style={{ width: "18%", height: "20%" }}
              >
                <Form.Group className="p-0 m-0">
                  <DatePicker
                    dateFormat="dd/MM/yyyy"
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    className="form-control rounded-100"
                    placeholderText="Start Date"
                  />
                </Form.Group>
              </div>
              <div
                className="px-1 p-0 m-0"
                style={{ width: "18%", height: "20%" }}
              >
                <Form.Group className="p-0 m-0">
                  <DatePicker
                    dateFormat="dd/MM/yyyy"
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    className="form-control rounded-100"
                    placeholderText="End Date"
                  />
                </Form.Group>
              </div>
                                <div
                                  className="pl-1 p-0 m-0"
                                  style={{ width: "14%", height: "20%" }}
                                >
                                  <Form.Group className="mt-0 p-0 m-0">
                                    <Button
                                      className=" btn btn-primary btn-lg btn-block "
                                      style={{
                                        background: "#4267B2",
                                        color: "white",
                                      }}
                                      onClick={fetchData}
                                    >
                                      {"Search"}
                                    </Button>
                                  </Form.Group>
                                </div>
                  
                                <div
                                  className="m-0 p-0 hover-container"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    ExportToExcel(
                                      `USER_LOGIN_DETAILST${now()}`,
                                      excelMapping(data, columns)
                                    );
                                  }}
                                >
                                  <img
                                    className="pl-1 p-0"
                                    src={require("../../../assets/images/download Icon.png")}
                                    style={{ width: `3.5rem`, height: "85%" }}
                                  />
                                  <div style={positionStyle1} className="hover-text bg-dark ">
                                    Export to Excel
                                  </div>
                                </div>
                              </div>
                            </div>
                </div>

                <hr className="m-0 p-0" />

                <div style={{ width: "100%" }}>
                    <div style={{ alignItems: "center" }}>
                        <div style={{ flex: "1" }}></div>
                    </div>
                </div>
                <div className=" scroll-inner admin-fix-width borderless-table ">
                    <table
                        className="my-table transparent-table text-center border-bottom"
                        style={{
                            width: "100%",
                            overflowX: "auto",
                            border: "0px",
                            overflow: "auto",
                        }}
                    >
                        <tr className="borderless-table text-center border-bottom">
                            <th
                                className="my-table transparent-table text-center border-bottom "
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    lineHeight: "24px",
                                    letterSpacing: "0em",
                                    textAlign: "center",
                                }}
                            >
                                {" "}
                                {"Sr"}
                            </th>
                            <th
                                className="my-table transparent-table text-center border-bottom "
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    lineHeight: "24px",
                                    letterSpacing: "0em",
                                    textAlign: "center",
                                }}
                            >
                                User ID
                            </th>
                            <th
                                className="my-table transparent-table text-center border-bottom "
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    lineHeight: "24px",
                                    letterSpacing: "0em",
                                    textAlign: "center",
                                }}
                            >
                                Mobile
                            </th>
                            <th
                                className="my-table transparent-table text-center border-bottom "
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    lineHeight: "24px",
                                    letterSpacing: "0em",
                                    textAlign: "center",
                                }}
                            >
                                IP Address
                            </th>
                            <th
                                className="my-table transparent-table text-center border-bottom "
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    lineHeight: "24px",
                                    letterSpacing: "0em",
                                    textAlign: "center",
                                }}
                            >
                                Latitude
                            </th>
                            <th
                                className="my-table transparent-table text-center border-bottom "
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    lineHeight: "24px",
                                    letterSpacing: "0em",
                                    textAlign: "center",
                                }}
                            >
                                Longitude
                            </th>

                            <th
                                className="my-table transparent-table text-center border-bottom "
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    lineHeight: "24px",
                                    letterSpacing: "0em",
                                    textAlign: "center",
                                }}
                            >
                                Device ID
                            </th>
                            <th
                                className="my-table transparent-table text-center border-bottom "
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    lineHeight: "24px",
                                    letterSpacing: "0em",
                                    textAlign: "center",
                                }}
                            >
                                Device Type
                            </th>
                            <th
                                className="my-table transparent-table text-center border-bottom "
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    lineHeight: "24px",
                                    letterSpacing: "0em",
                                    textAlign: "center",
                                }}
                            >
                                Device Model
                            </th>
                            <th
                                className="my-table transparent-table text-center border-bottom "
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    lineHeight: "24px",
                                    letterSpacing: "0em",
                                    textAlign: "center",
                                }}
                            >
                                User Agent
                            </th>

                            <th
                                className="my-table transparent-table text-center border-bottom "
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    lineHeight: "24px",
                                    letterSpacing: "0em",
                                    textAlign: "center",
                                }}
                            >
                                App Version
                            </th>
                            <th
                                className="my-table transparent-table text-center border-bottom "
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    lineHeight: "24px",
                                    letterSpacing: "0em",
                                    textAlign: "center",
                                }}
                            >
                                Suspicious
                            </th>
                            <th
                                className="my-table transparent-table text-center border-bottom "
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    lineHeight: "24px",
                                    letterSpacing: "0em",
                                    textAlign: "center",
                                }}
                            >
                                Status
                            </th>
                            <th
                                className="my-table transparent-table text-center border-bottom "
                                style={{
                                    fontFamily: "Poppins",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    lineHeight: "24px",
                                    letterSpacing: "0em",
                                    textAlign: "center",
                                }}
                            >
                                Attempt Time
                            </th>
                        </tr>
                        {dataToDisplay.map((e, ind) => (
                            <tr className="border-bottom clickable-row">
                                <td
                                    className="text-center border-bottom"
                                    style={{
                                        fontSize: "0.8rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        lineHeight: "24px",
                                        letterSpacing: "0em",
                                        textAlign: "center",
                                    }}
                                >
                                    {" "}
                                    {ind + 1}
                                </td>
                                <td
                                    className="text-center border-bottom"
                                    style={{
                                        fontSize: "0.8rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        lineHeight: "24px",
                                        letterSpacing: "0em",
                                        textAlign: "center",
                                    }}
                                >
                                    <div>{e.user_id}</div>
                                </td>
                                <td
                                    className="text-center border-bottom"
                                    style={{
                                        fontSize: "0.8rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        lineHeight: "24px",
                                        letterSpacing: "0em",
                                        textAlign: "center",
                                    }}
                                >
                                    <div>{e.mobile}</div>
                                </td>

                                <td
                                    className="text-center border-bottom"
                                    style={{
                                        fontSize: "0.8rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        lineHeight: "24px",
                                        letterSpacing: "0em",
                                        textAlign: "center",
                                    }}
                                >
                                    <div>{e.ip_address}</div>
                                </td>
                                <td
                                    className="text-center border-bottom"
                                    style={{
                                        fontSize: "0.8rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        lineHeight: "24px",
                                        letterSpacing: "0em",
                                        textAlign: "center",
                                    }}
                                >
                                    <div>{e.latitude}</div>
                                </td>
                                <td
                                    className="text-center border-bottom"
                                    style={{
                                        fontSize: "0.8rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        lineHeight: "24px",
                                        letterSpacing: "0em",
                                        textAlign: "center",
                                    }}
                                >
                                    <div>{e.longitude}</div>
                                </td>
                                <td
                                    className="text-center border-bottom"
                                    style={{
                                        fontSize: "0.8rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        lineHeight: "24px",
                                        letterSpacing: "0em",
                                        textAlign: "center",
                                    }}
                                >
                                    <div>{e.device_id}</div>
                                </td>
                                <td
                                    className="text-center border-bottom"
                                    style={{
                                        fontSize: "0.8rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        lineHeight: "24px",
                                        letterSpacing: "0em",
                                        textAlign: "center",
                                    }}
                                >
                                    <div>{e.device_type}</div>
                                </td>
                                <td
                                    className="text-center border-bottom"
                                    style={{
                                        fontSize: "0.8rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        lineHeight: "24px",
                                        letterSpacing: "0em",
                                        textAlign: "center",
                                    }}
                                >
                                    <div>{e.device_model}</div>
                                </td>
                                <td
                                    className="text-center text-bold border-bottom"
                                    style={{
                                        fontSize: "0.8rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        lineHeight: "24px",
                                        letterSpacing: "0em",
                                        textAlign: "center",
                                    }}
                                >
                                    <div>{e.user_agent}</div>
                                </td>
                                <td
                                    className="text-center text-bold border-bottom"
                                    style={{
                                        fontSize: "0.8rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        lineHeight: "24px",
                                        letterSpacing: "0em",
                                        textAlign: "center",
                                    }}
                                >
                                    <div>{e.app_version}</div>
                                </td>
                                <td
                                    className="text-center text-bold border-bottom"
                                    style={{
                                        fontSize: "0.8rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        lineHeight: "24px",
                                        letterSpacing: "0em",
                                        textAlign: "center",
                                    }}
                                >
                                    <div>{e.is_suspicious}</div>
                                </td>
                                <td
                                    className="text-center text-bold border-bottom"
                                    style={{
                                        fontSize: "0.8rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        lineHeight: "24px",
                                        letterSpacing: "0em",
                                        textAlign: "center",
                                    }}
                                >
                                    <div>{e.is_success}</div>
                                </td>
                                <td
                                    className="text-center text-bold border-bottom"
                                    style={{
                                        fontSize: "0.8rem",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        lineHeight: "24px",
                                        letterSpacing: "0em",
                                        textAlign: "center",
                                    }}
                                >
                                    <div>{e.attempt_time}</div>
                                </td>

                            </tr>
                        ))}
                    </table>
                </div>
                <Pagination
                    page={currentPage}
                    limit={pages}
                    callback={(page) => {
                        setCurrentPage(page);
                    }}
                    count={dataToDisplay.length}
                    total={total}
                    callback2={(offsetValue) => {
                        setOffset(offsetValue);
                    }}
                />
            </div>
        </>
    );
};

export const Pagination = ({
    page,
    limit,
    callback,
    total,
    count,
    callback2,
}) => {
    console.table({ page, limit, callback });
    const selectStyleLeftBorder = {
        borderRadius: "0px",
        fontFamily: "Poppins",
        fontsize: "16px",
        borderRight: "1px solid rgba(0, 0, 0, 0.2)", // Remove the border
        borderRadius: "0px",
        borderLeft: "none", // Remove right side border
        borderTop: "none", // Remove top border
        borderBottom: "none", // Remove bottom border
        fontFamily: "Poppins",
        fontsize: "16px",
    };
    const selectStyleBorder = {
        border: "1px solid rgba(0, 0, 0, 0.1)", // Remove the border
        borderRadius: "8px",
        fontFamily: "Poppins",
        fontsize: "16px",
    };
    const selectStyle = {
        border: "none", // Remove the border
        fontFamily: "Poppins",
        fontsize: "16px",
    };
    return (
        <div
            className="row"
            style={{
                display: "flex",
                alignItems: "end",
                width: "100%",
                margin: "12px 0px",
                justifyContent: "space-between",
            }}
        >
            <div style={{ fontFamily: "Poppins" }}>
                <strong>{`Showing ${count} of ${total} entries`}</strong>
            </div>

            <div className="d-flex btn-group p-1" style={selectStyleBorder}>
                <select
                    style={selectStyleLeftBorder}
                    className=" d-flex justify-content-end "
                    aria-label="offset"
                    onChange={(e) => {
                        callback2(e.target.value);
                    }}
                >
                    {offsetArr.map((offset) => (
                        <option value={offset} className="d-flex justify-content-end">
                            {offset}
                        </option>
                    ))}
                </select>
                {page - 2 > 0 ? (
                    <Button
                        onClick={() => {
                            callback(page - 1);
                        }}
                        className="rounded-0 bg-white text-dark border-white"
                    >
                        {"<<"}
                    </Button>
                ) : null}

                {page - 1 > 0 ? (
                    <Button
                        onClick={() => {
                            callback(page - 1);
                        }}
                        className="rounded-0 bg-white text-dark border-white underline-text"
                    >
                        {" "}
                        {(page - 1).toString()}
                    </Button>
                ) : null}

                <Button className="bg-white text-primary " style={selectStyle}>
                    {" "}
                    {page.toString()}
                </Button>

                {/* Next And Previous Button Code */}
                {page + 1 <= limit ? (
                    <Button
                        onClick={() => {
                            callback(page + 1);
                        }}
                        className="rounded-0 bg-white text-dark border-white"
                    >
                        {">>"}
                    </Button>
                ) : null}
            </div>
        </div>
    );
};

export default UserAttemptsTable;
